import { render, staticRenderFns } from "./FeedItemMeeting.vue?vue&type=template&id=695765c2&scoped=true&"
import script from "./FeedItemMeeting.vue?vue&type=script&lang=js&"
export * from "./FeedItemMeeting.vue?vue&type=script&lang=js&"
import style0 from "./FeedItemMeeting.vue?vue&type=style&index=0&id=695765c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695765c2",
  null
  
)

export default component.exports